module.exports = __webpack_public_path__ + "static/media/bt_top_lifecheck_normal.fa0b74f5.png";